import { MdDeviceHub, MdDirectionsWalk, MdDns, MdDoorFront, MdLock, MdRouter, MdSettingsRemote } from "react-icons/md";

// ─── Mock data ───────────────────────────────────────────────────────────────
export const MOCK_ACCESS_MODULES = [
   {
      id: "group-main-entrance",
      type: "group",
      label: "Main Entrance",
      icon: "folder",
      children: [
         {
            id: "mod-1",
            type: "item",
            label: "Native Door - Lobby",
            moduleType: 0,
            icon: "door",
            description: "Main lobby native door",
         },
         {
            id: "mod-2",
            type: "item",
            label: "Door Module - Reception",
            moduleType: 1,
            icon: "door",
            description: "Reception door module",
         },
         {
            id: "mod-3",
            type: "item",
            label: "RF Receiver - Entrance",
            moduleType: 2,
            icon: "rf",
            description: "Entrance RF receiver",
         },
      ],
   },
   {
      id: "group-parking",
      type: "group",
      label: "Parking",
      icon: "folder",
      children: [
         {
            id: "mod-4",
            type: "item",
            label: "IP Door Module - Gate A",
            moduleType: 12,
            icon: "ip",
            description: "Gate A IP door",
         },
         {
            id: "mod-5",
            type: "item",
            label: "Turnstile - Parking Entry",
            moduleType: 8,
            icon: "turnstile",
            description: "Parking entry turnstile",
         },
         {
            id: "mod-6",
            type: "item",
            label: "IP RF Receiver - Parking",
            moduleType: 13,
            icon: "ip",
            description: "Parking IP RF receiver",
         },
      ],
   },
   {
      id: "group-elevators",
      type: "group",
      label: "Elevators",
      icon: "folder",
      children: [
         {
            id: "mod-7",
            type: "item",
            label: "IP Turnstile - Elevator A",
            moduleType: 14,
            icon: "turnstile",
            description: "Elevator A IP turnstile",
         },
         {
            id: "mod-8",
            type: "item",
            label: "Door Module - Elevator B",
            moduleType: 1,
            icon: "door",
            description: "Elevator B door module",
         },
      ],
   },
   {
      id: "mod-9",
      type: "item",
      label: "Native Door - Side Gate",
      moduleType: 0,
      icon: "door",
      description: "Side gate native door",
   },
   {
      id: "mod-10",
      type: "item",
      label: "RF Receiver - Pool Area",
      moduleType: 2,
      icon: "rf",
      description: "Pool area RF receiver",
   },
   {
      id: "group-security",
      type: "group",
      label: "Security",
      icon: "folder",
      children: [
         {
            id: "mod-11",
            type: "item",
            label: "Door Module - Security Room",
            moduleType: 1,
            icon: "door",
            description: "Security room door",
         },
         {
            id: "mod-12",
            type: "item",
            label: "IP Door - Server Room",
            moduleType: 12,
            icon: "ip",
            description: "Server room IP door",
         },
         {
            id: "mod-13",
            type: "item",
            label: "Turnstile - Staff Entry",
            moduleType: 8,
            icon: "turnstile",
            description: "Staff entry turnstile",
         },
      ],
   },
   {
      id: "mod-14",
      type: "item",
      label: "Native Door - Gym",
      moduleType: 0,
      icon: "door",
      description: "Gym native door",
   },
   {
      id: "mod-15",
      type: "item",
      label: "RF Receiver - Garden",
      moduleType: 2,
      icon: "rf",
      description: "Garden RF receiver",
   },
];

// ─── Icon helpers ─────────────────────────────────────────────────────────────
const ITEM_ICON_MAP = {
   door: <MdDoorFront size={15} />,
   rf: <MdSettingsRemote size={15} />,
   turnstile: <MdDirectionsWalk size={15} />,
   ip: <MdRouter size={15} />,
   hub: <MdDeviceHub size={15} />,
   server: <MdDns size={15} />,
   lock: <MdLock size={15} />,
};

export function getItemIcon(icon) {
   return ITEM_ICON_MAP[icon] || <MdLock size={15} />;
}